import { InputSignatureState, } from '@kubit/web-ui-components/inputSignature/types';
import { commonStyles } from '../commonStyles';
import { InputSignatureVariants } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => ({
    [InputSignatureVariants.DEFAULT]: {
        signatureStyle: {
            color: String(FOUNDATIONS.color_neutral_font_50),
            lineWidth: 2,
        },
        [InputSignatureState.DEFAULT]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    border_color: FOUNDATIONS.color_neutral_border_150,
                },
            }),
        },
        [InputSignatureState.ACTIVE]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                },
            }),
        },
        [InputSignatureState.DISABLED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                placeholderText: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            }),
        },
        [InputSignatureState.ERROR]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                    border_color: FOUNDATIONS.color_feedback_error_border_50,
                },
                placeholderText: {
                    color: FOUNDATIONS.color_feedback_error_font_50,
                },
            }),
        },
        [InputSignatureState.FILLED]: {
            ...commonStyles(FOUNDATIONS, {
                container: {
                    border_color: FOUNDATIONS.color_neutral_border_50,
                },
            }),
        },
    },
});
//# sourceMappingURL=default.js.map